export const RESET = 'EXCMCUSTOMFIELDVALUE_LIST_RESET'
export const SET_ITEMS = 'EXCMCUSTOMFIELDVALUE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCUSTOMFIELDVALUE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCUSTOMFIELDVALUE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCUSTOMFIELDVALUE_LIST_TOGGLE_LOADING'
